import api from './api';

export const taskService = {
    // Get all tasks
    getAllTasks: async (filters = {}) => {
        const response = await api.get('/tasks', { params: filters });
        return response.data;
    },

    // Get my tasks
    getMyTasks: async () => {
        const response = await api.get('/tasks/my-tasks');
        return response.data;
    },

    // Get single task
    getTask: async (id) => {
        const response = await api.get(`/tasks/${id}`);
        return response.data;
    },

    // Create task
    createTask: async (taskData) => {
        const response = await api.post('/tasks', taskData);
        return response.data;
    },

    // Update task (full update)
    updateTask: async (id, taskData) => {
        const response = await api.put(`/tasks/${id}`, taskData);
        return response.data;
    },

    // Update task status ONLY (use PATCH to /status endpoint)
    updateTaskStatus: async (id, status) => {
        const response = await api.patch(`/tasks/${id}/status`, { status });
        return response.data;
    },

    // Delete task
    deleteTask: async (id) => {
        const response = await api.delete(`/tasks/${id}`);
        return response.data;
    },

    // Add comment
    addComment: async (id, comment) => {
        const response = await api.post(`/tasks/${id}/comments`, { comment });
        return response.data;
    },
    getTaskStats: async () => {
        const response = await api.get('/tasks/stats');
        return response.data;
    }
};